var modal = document.getElementById("geoModal");
// Get the <span> element that closes the modal
var closeSpan = document.getElementById("close-geo-modal");
// When the user clicks on <span> (x), close the modal
var modalBody = document.getElementsByClassName("modal-body")[0];


console.log("closeSpan",closeSpan)
closeSpan.onclick = function() {
  sessionStorage.setItem("shopUS", "true");
  modal.style.display = "none";
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
}


function setModalContent(content) {
  console.log("Set content ", content)
  modalBody.innerHTML = content;
}


function getLocation() {
  if (sessionStorage.getItem("shopUS")) {
    console.log("Shop US")
    return;
  }
  
  console.log("GEOLOCATION")
  $.get("https://ipinfo.io", function(response) {
        console.log(response.city, response.country);
        if (response.country != 'NI' && response.country != 'CR' && response.country != 'PA') return;
        if (response.country == "NI") {
          setModalContent("<p>It looks like you are visiting us from Nicaragua.  For local pricing visit our Nicaraguan online store at <a href='https://masayacompany.com.ni/'>Masaya Co Nicaragua</a></p>")
        }
        if (response.country == "CR") {
          setModalContent("<p>It looks like you are visiting us from Costa Rica.  For local pricing visit our Costa Rican online store at <a href='https://masayacompany.cr/'>Masaya Co Costa Rica</a></p>")
        }
        if (response.country == "PA") {
          setModalContent("<p>It looks like you are visiting us from Panama.  For local pricing visit our Panama online store at <a href='https://masayacompany.pa/'>Masaya Co Panama</a></p>")
        }
        modal.style.display = "block";

    }, "jsonp");
  
}

function defer(method) {
  console.log("DEFER")
    if (window.jQuery) {
        method();
    } else {
        setTimeout(function() { defer(method) }, 50);
    }
}


defer(getLocation);

